// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"45d844de","453":"acaa4f5d","455":"75b31657","977":"34e08662"}[chunkId] + ".chunk.js";
};